import { useState } from 'react'
import { Icone, type NomIcone } from './composants/Icone'

type Theme = 'systeme' | 'clair' | 'sombre'
const CHOIX: { theme: Theme; icone: NomIcone; libelle: string; court?: boolean }[] = [
  { theme: 'systeme', icone: 'contrast', libelle: 'Thème du système', court: true },
  { theme: 'clair', icone: 'light_mode', libelle: 'Clair' },
  { theme: 'sombre', icone: 'dark_mode', libelle: 'Sombre' },
]

function lire(): Theme {
  try {
    const t = localStorage.getItem('theme')
    return t === 'clair' || t === 'sombre' ? t : 'systeme'
  } catch {
    return 'systeme'
  }
}

function appliquer(theme: Theme) {
  if (theme === 'systeme') delete document.documentElement.dataset.theme
  else document.documentElement.dataset.theme = theme
  try {
    if (theme === 'systeme') localStorage.removeItem('theme')
    else localStorage.setItem('theme', theme)
  } catch {
    // Stockage indisponible : le thème vaut pour la session.
  }
}

export function BasculeTheme() {
  const [theme, setTheme] = useState<Theme>(lire)
  return (
    <div className="choix-theme" role="group" aria-label="Thème">
      {CHOIX.map((c) => (
        <button
          key={c.theme}
          type="button"
          aria-pressed={theme === c.theme}
          aria-label={c.court ? c.libelle : undefined}
          title={c.libelle}
          style={c.court ? { flex: 'none', padding: '6px 9px' } : undefined}
          onClick={() => {
            appliquer(c.theme)
            setTheme(c.theme)
          }}
        >
          <Icone nom={c.icone} taille={17} />
          {!c.court && <span>{c.libelle}</span>}
        </button>
      ))}
    </div>
  )
}
